export default __webpack_public_path__ + "static/media/quote.2bad2f92.svg";